/**
 * Removes all null, undefined and empty string properties (keys) in object.
 * @param obj
 */
export function cleanObject(obj: any) {
  if (!obj || typeof obj !== 'object') return obj;

  for (var propName in obj) {
    if (obj[propName] === undefined || obj[propName] === null || obj[propName] === '') {
      delete obj[propName];
    }
  }

  return obj;
}
